export default function uploadFile(Url, data) {
    //上传图片的方法
    return new Promise((resolve, reject) => {
        let instance = axios.create({
            // baseURL: 'https://ht.tjjianan.com/',
            baseURL:"http://ht.tjjianan.com",
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        instance.post(Url, data).then(res => {
            resolve(res.data.data);
        }).catch(error => {
            reject(error.data)
        })
    });
}
